export default "__VITE_ASSET__rmpRf5UC__"